module.exports = __webpack_public_path__ + "static/Sporting_Grotesque-Bold_web-918604173bb90fba43e176e056894c0c.ttf";